import { render, staticRenderFns } from "./ContainerView.vue?vue&type=template&id=365a8046&scoped=true&"
import script from "./ContainerView.vue?vue&type=script&lang=js&"
export * from "./ContainerView.vue?vue&type=script&lang=js&"
import style0 from "./ContainerView.vue?vue&type=style&index=0&id=365a8046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a8046",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VDataTable,VRow,VSelect,VSpacer,VTextField})
